import {RouteComponentProps} from 'react-router';
import {CreateChecklistArgs, IdPageUrlParams} from "../paths";
import * as qs from "query-string";
import {DateRange} from "../common/dtos";
import {toMoment} from "./date-utils";

export const cacheComponentStateForLocation = (props: RouteComponentProps, state: {}) => {
  props.history.replace(props.location.pathname, state);
};

export const idFromPathParams = (props: RouteComponentProps<IdPageUrlParams>): number => {
  const idParam = props.match.params.id;
  return Number(idParam);
}

export const checklistIdsFromPathParams = (props: RouteComponentProps<IdPageUrlParams>): CreateChecklistArgs => {
  const rentalItemId = stringFromQueryParams(props, 'rentalItemId')
  const rentalId = stringFromQueryParams(props, 'rentalId')
  const returnalId = stringFromQueryParams(props, 'returnalId')
  return {
    rentalItemId: Number(rentalItemId),
    rentalId: rentalId ? Number(rentalId) : undefined,
    returnalId: returnalId ? Number(returnalId) : undefined
  };
}

export const stringFromQueryParams = (props: RouteComponentProps, key: string): string | undefined => {
  const urlParams = qs.parse(props.location.search);
  const prop = urlParams[key];
  return prop ? prop as string : undefined;
}

export const dateRangeFromQueryParams = (props: RouteComponentProps): DateRange | undefined => {
  const start = toMoment(stringFromQueryParams(props, 'start'));
  const end = toMoment(stringFromQueryParams(props, 'end'));
  return start && end ? {start, end} : undefined;
}


// WEBPACK FOOTER //
// ./src/utils/router-utils.tsx